export const findHtmlElement = (selectorOrElement, container) => {
	if (!selectorOrElement) return undefined
	if (container && !(container instanceof HTMLElement)) return undefined

	if (selectorOrElement instanceof HTMLElement) return selectorOrElement

	return container
		? container.querySelector(selectorOrElement)
		: document.querySelector(selectorOrElement)
}

export const findNodeList = (selectorOrElements, container) => {
	const isValidContainer = container && container instanceof HTMLElement
	const parentElement = isValidContainer ? container : document

	if (typeof selectorOrElements === 'string') {
		return [...parentElement.querySelectorAll(selectorOrElements)]
	}

	return selectorOrElements
}
